import { create } from 'zustand'

interface MeetingActiveState {
  meetingActive: boolean
  setMeetingActive: (active: boolean) => void
}

/**
 * 在席中（アクティブな会議セッション）かどうかを表すグローバルフラグ（Task 32）。
 *
 * `MeetingLivePage` の `sessionActive`（`isConnected || isRecording || !!currentSession`）
 * と同期させ、`AppLayout`（`Outlet` の外側でルート全体をラップする骨格レイアウト）が
 * モバイル下端 UI（`BottomTabBar` × `AudioBar` 下端競合対策）を判断するために使う。
 *
 * `appStore` の `realtimeSession` は会議終了後も PostMeetingWizard の transcripts 表示の
 * ため意図的にクリアされない（stale になり得る）ため、「いま本当に在席中か」の判定には
 * 使えない。本ストアは `MeetingLivePage` が明示的に同期する専用フラグとして分離する。
 */
export const useMeetingActiveStore = create<MeetingActiveState>((set) => ({
  meetingActive: false,
  setMeetingActive: (active) => set({ meetingActive: active }),
}))

export const useMeetingActive = () =>
  useMeetingActiveStore((s) => s.meetingActive)

export const useSetMeetingActive = () =>
  useMeetingActiveStore((s) => s.setMeetingActive)
